import PageHeader from '@/components/feature/PageHeader';
import About from './components/About';
import Values from './components/Values';
import Team from './components/Team';

export default function AboutPage() {
  return (
    <>
      <PageHeader
        title="À propos de Godwin Logistics"
        subtitle="Un commissionnaire de transport international qui connecte les continents et simplifie la complexité du commerce mondial depuis la Chine."
        image="https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20international%20container%20shipping%20port%20terminal%20with%20orange%20cranes%20loading%20cargo%20vessels%20at%20golden%20hour%2C%20warm%20amber%20tones%2C%20industrial%20maritime%20logistics%20hub%20in%20China%2C%20atmospheric%20depth%2C%20editorial%20photography%2C%20high%20detail%20professional%20composition&width=1800&height=800&seq=gls-page-about&orientation=landscape"
      />
      <About />
      <Values />
      <Team />
    </>
  );
}